'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function BodyClassManager() {
  const pathname = usePathname();

  useEffect(() => {
    const isLandingPage = pathname?.includes('/squaretrade');
    
    if (isLandingPage) {
      document.body.classList.add('landing-page');
    } else {
      document.body.classList.remove('landing-page');
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove('landing-page');
    };
  }, [pathname]);

  return null;
}
